export default "__VITE_ASSET__de72e06f__"